var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tabs"},[_c('ul',[_c('router-link',{attrs:{"tag":"li","to":"/system","active-class":"is-active","exact":""}},[_c('a',[_vm._v("System settings")])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/system/currencies","active-class":"is-active"}},[_c('a',[_vm._v("Currencies")])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/system/ps","active-class":"is-active"}},[_c('a',[_vm._v("Payment system")])])],1)]),_vm._v(" "),_c('div',[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/system/index.vue?vue&type=template&id=725844c3
// module id = kxbJ
// module chunks = 0